import { z } from 'zod';
import { pageParam, pageSizeParam } from '../_shared/coerce.js';
const ESTIMATE_TYPE_FILTERS = ['ALL', 'FLIGHT', 'TOURISM'];
const ESTIMATE_TAB_STATUSES = [
    'ALL',
    'PENDING',
    'AWAITING_RESPONSE',
    'RESERVATION_PENDING',
    'COMPLETED',
    'EXPIRED',
    'POUR_PLUS_TARD',
];
const TRAVEL_TYPE_FILTERS = [
    'ALL',
    'ONE_WAY',
    'ROUND_TRIP',
    'MULTI_DESTINATION',
    'CRUISE',
    'STAY',
    'TOUR',
];
/**
 * PPT — rangement/sortie manuels de « Pour plus tard ». `notifyClient` déclenche
 * la notification tarifaire (56 au rangement, 55 à la sortie), idempotente par
 * devis.
 */
export const setEstimateSnoozedSchema = z.object({
    notifyClient: z.boolean().optional().default(false),
    snoozed: z.boolean(),
});
export const getEstimatesQuerySchema = z.object({
    clientId: z.string().optional(),
    agency: z.enum(['ALL', 'MRS', 'RUN']).optional(),
    estimateType: z.enum(ESTIMATE_TYPE_FILTERS).optional().default('ALL'),
    page: pageParam(),
    pageSize: pageSizeParam(),
    search: z.string().optional(),
    sortBy: z.enum(['createdAt', 'departureDate', 'returnDate']).optional(),
    sortOrder: z.enum(['asc', 'desc']).optional(),
    tab: z.enum(ESTIMATE_TAB_STATUSES).optional().default('ALL'),
    travelType: z.enum(TRAVEL_TYPE_FILTERS).optional().default('ALL'),
});
